import { AES } from 'crypto-js';

export const encrypt = phrase => AES.encrypt(phrase, process.env.REACT_APP_ENCRYPTION_KEY);